module.exports = __webpack_public_path__ + "static/contact-dbf5c192a168f8a931e2722d86397d90.jpg";